import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { MedicineService } from "./medicine.services";
import { LocationService } from "./location.services";

@Injectable()
export class EventBusService {
  constructor(
    private medicineService: MedicineService,
    private locationService: LocationService
  ) {}

  public profilepicSource = new Subject<any>();
  public profilepicFetchedValue$ = this.profilepicSource.asObservable();

  public profileStateSource = new Subject<any>();
  public profileStateFetchedValue$ = this.profileStateSource.asObservable();

  public profileCitySource = new Subject<any>();
  public profileCityFetchedValue$ = this.profileCitySource.asObservable();

  public viewMedicineDetailSource = new Subject<any>();
  public viewMedicineDetailValue$ = this.viewMedicineDetailSource.asObservable();

  public locationsSource = new Subject<any>();
  public locationsValue$ = this.locationsSource.asObservable();

  public realtimeEventSource = new Subject<any>();
  public realtimeEventValue$ = this.realtimeEventSource.asObservable();

  public locationsListSource = new Subject<any>();
  public locationsListValue$ = this.locationsListSource.asObservable();

  public allLocationsSource = new Subject<any>();
  public allLocationsValue$ = this.allLocationsSource.asObservable();

  public productsListSource = new Subject<any>();
  public productsListValue$ = this.productsListSource.asObservable();

  public onReadySource = new Subject<any>();
  public onReadyValue$ = this.onReadySource.asObservable();

  public particpantSelectionSource = new Subject<any>();
  public particpantSelectionFetchedValue$ = this.particpantSelectionSource.asObservable();

  public assetSource = new Subject<any>();
  public assetFetchedValue$ = this.assetSource.asObservable();

  public hideGcpChangeSource = new Subject<any>();
  public hideGcpChangeValue$ = this.hideGcpChangeSource.asObservable();

  public toggleDrawerSource = new Subject<any>();
  public toggleDrawerValue$ = this.toggleDrawerSource.asObservable();

  public getMedicineDetail(rec) {
    //TODO: We need to get rid of these pagination fields as we need a single medicine detail
    rec['bookmark'] = '';
		rec['pageSize'] = 5;
    this.medicineService.details(rec).subscribe((response: any[]) => {
      if (response['result'].length > 0) {
        this.viewMedicineDetailSource.next(response['result'][0]);
      }
    });
  }

  public loadLocations(rec) {
    this.locationService.locationSummary(rec).subscribe(response => {
      this.locationsSource.next(response);
    });
  }

  public getLocationByMedicine(id) {
    this.locationService.getByMedicine(id).subscribe(response => {
      this.locationsSource.next(response);
    });
  }


  loadProductsList(gcp) {
    this.medicineService.getList(gcp).subscribe(
      (response: any) => {
        this.productsListSource.next(response);
    });
  }

  loadLocationsList(gcp) {
    this.locationService.getList(gcp).subscribe(
      (response: any) => {
        this.locationsListSource.next(response);
    });
  }

  loadAllLocations(gcp) {
    this.locationService.get(gcp).subscribe(
      (response: any) => {
        this.allLocationsSource.next(response);
    });
  }
}
